import { Page, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 24,
  },
});

type PdfPageProps = {
  children: React.ReactNode;
};

export const PdfPage = ({ children }: PdfPageProps) => {
  return (
    <Page size="A4" style={styles.page}>
      {children}
    </Page>
  );
};
